export default {
  en: {
    product: "Agent Platform",
    skip: "Skip to main content",
    navLabel: "Main navigation",
    tenant: "Organisation: {{tenant}}",
    testMode: "Test sign-in",
    switchLanguage: "Switch language to Arabic",
    userMenu: "Account menu",
    logout: "Sign out",
    switchUser: "Switch user",
    notFound: "Page not found",
    forbidden: {
      title: "Access denied",
      body: "Your roles do not include access to this console.",
      needs: "This page is for people with one of these roles: {{roles}}.",
      sep: ", ",
      askOrg: "Ask your organisation administrator to give you one of them (Administration › Users & roles).",
      askPlatform: "These roles are given by the platform team.",
    },
    hiddenTabs: "More tabs on this page are for other roles: {{tabs}}.",
    group: { work: "Work", build: "Build", govern: "Govern", observe: "Observe", tools: "Engineering tools" },
    toolsHint: "Opens an advanced tool",
    rail: { collapse: "Collapse navigation", expand: "Expand navigation", openMenu: "Open menu", closeMenu: "Close menu", home: "Agent Platform home" },
    theme: { toDark: "Switch to dark mode", toLight: "Switch to light mode", dark: "Dark mode", light: "Light mode" },
    langShort: "ع",
    help: "Help",
    searchJump: "Search or jump to…",
    breadcrumb: "You are here",
    tenantChip: "Organisation",
    platformTeam: "Platform team",
    account: { signedInAs: "Signed in as {{name}}", roles: "Roles: {{count}}" },
    nav: {
      chat: "Assistant", inbox: "Reviewer inbox", cases: "Cases", builder: "Builder", models: "Models", governance: "Governance",
      operator: "Operations", executive: "Executive", temporal: "Workflows (Temporal)", mlflow: "Experiments (MLflow)", grafana: "Dashboards (Grafana)",
      privacy: "Privacy", knowledge: "Knowledge", dataTables: "Data tables", bulkRuns: "Run on many items", admin: "Administration", channels: "Channels",
      home: "Home", howItWorks: "How it fits together", dataLevels: "Data levels", glossary: "Glossary", guide: "User guide",
      activity: "Activity", command: "Command Centre", health: "Health and usage", quality: "Quality",
    },
    userId: "User ID: {{id}}",
    copyUserId: "Copy my user ID",
    copied: "Copied",
    allOrgs: "This applies to all organisations on the platform.",
    platformScope: {
      title: "{{org}} · {{roles}}",
      note: "Your platform roles act on what all organisations share: AI models, systems and tools, platform settings and the global emergency stop. They do not let you read other organisations' conversations, documents or cases.",
    },
    embedded: {
      title: "{{tool}}",
      subtitle: "It opens here with your usual sign-in.",
      openNew: "Open in a new tab",
      frameTitle: "{{tool}} console",
      advanced: "Advanced view",
      purpose: {
        temporal: "The advanced, technical view of every run's step-by-step workflow, for engineers investigating a stuck or failed run.",
        mlflow: "The advanced, detailed view of quality-check results, experiments and instruction versions, for builders and model administrators.",
        grafana: "The advanced, technical view of live system metrics and dashboards, for operators and auditors.",
      },
    },
  },
  ar: {
    product: "منصة الوكلاء",
    skip: "تخطَّ إلى المحتوى الرئيسي",
    navLabel: "التنقل الرئيسي",
    tenant: "الجهة: {{tenant}}",
    testMode: "دخول اختباري",
    switchLanguage: "تبديل اللغة إلى الإنجليزية",
    userMenu: "قائمة الحساب",
    logout: "تسجيل الخروج",
    switchUser: "تبديل المستخدم",
    notFound: "الصفحة غير موجودة",
    forbidden: {
      title: "الوصول مرفوض",
      body: "أدوارك لا تتضمن الوصول إلى هذه الواجهة.",
      needs: "هذه الصفحة لمن لديه أحد هذه الأدوار: {{roles}}.",
      sep: "، ",
      askOrg: "اطلب من مسؤول جهتك منحك أحدها (الإدارة › المستخدمون والأدوار).",
      askPlatform: "يمنح فريق المنصة هذه الأدوار.",
    },
    hiddenTabs: "في هذه الصفحة تبويبات أخرى لأدوار أخرى: {{tabs}}.",
    group: { work: "العمل", build: "البناء", govern: "الحوكمة", observe: "المراقبة", tools: "أدوات هندسية" },
    toolsHint: "يفتح أداة متقدمة",
    rail: { collapse: "طيّ قائمة التنقل", expand: "توسيع قائمة التنقل", openMenu: "فتح القائمة", closeMenu: "إغلاق القائمة", home: "الصفحة الرئيسية لمنصة الوكلاء" },
    theme: { toDark: "التبديل إلى الوضع الداكن", toLight: "التبديل إلى الوضع الفاتح", dark: "الوضع الداكن", light: "الوضع الفاتح" },
    langShort: "EN",
    help: "المساعدة",
    searchJump: "ابحث أو انتقل إلى…",
    breadcrumb: "أنت هنا",
    tenantChip: "الجهة",
    platformTeam: "فريق المنصة",
    account: { signedInAs: "تم الدخول باسم {{name}}", roles: "عدد الأدوار: {{count}}" },
    nav: {
      chat: "المساعد", inbox: "صندوق المراجعة", cases: "الحالات", builder: "المنشئ", models: "النماذج", governance: "الحوكمة",
      operator: "العمليات", executive: "لوحة القيادة", temporal: "سير العمل (Temporal)", mlflow: "التجارب (MLflow)", grafana: "لوحات المراقبة (Grafana)",
      privacy: "الخصوصية", knowledge: "المعرفة", dataTables: "جداول البيانات", bulkRuns: "التشغيل على عناصر كثيرة", admin: "الإدارة", channels: "القنوات",
      home: "الرئيسية", howItWorks: "كيف تترابط الأجزاء", dataLevels: "مستويات البيانات", glossary: "المصطلحات", guide: "دليل المستخدم",
      activity: "النشاط", command: "مركز القيادة", health: "الصحة والاستخدام", quality: "الجودة",
    },
    userId: "معرّف المستخدم: {{id}}",
    copyUserId: "نسخ معرّف المستخدم",
    copied: "تم النسخ",
    allOrgs: "ينطبق هذا على جميع الجهات في المنصة.",
    platformScope: {
      title: "{{org}} · {{roles}}",
      note: "تعمل أدوارك في المنصة على ما تتشاركه الجهات كلها: نماذج الذكاء الاصطناعي، والأنظمة والأدوات، وإعدادات المنصة، والإيقاف الطارئ الشامل. ولا تتيح لك قراءة محادثات الجهات الأخرى أو مستنداتها أو حالاتها.",
    },
    embedded: {
      title: "{{tool}}",
      subtitle: "تُفتح هنا بتسجيل دخولك المعتاد.",
      openNew: "فتح في علامة تبويب جديدة",
      frameTitle: "واجهة {{tool}}",
      advanced: "عرض متقدم",
      purpose: {
        temporal: "العرض الفني المتقدم لسير عمل كل تشغيل خطوة بخطوة، للمهندسين الذين يتحققون من تشغيل متوقف أو فاشل.",
        mlflow: "العرض المتقدم المفصّل لنتائج فحوص الجودة والتجارب وإصدارات التعليمات، للمنشئين ومسؤولي النماذج.",
        grafana: "العرض الفني المتقدم لمقاييس النظام الحية ولوحاته، للمشغّلين والمدققين.",
      },
    },
  },
};
